import React from 'react'
import { withState } from 'react-state-hoc'

import { Block, H2, P } from '../primitives'

const Error = ({ color, description, expanded, text, title, toggle }) => (
    <Block color={color} onClick={description ? toggle : null}>
        <H2>{title}</H2>
        {typeof text === 'string' ? (
            <P margin={8} dangerouslySetInnerHTML={{ __html: text }} />
        ) : (
            text
        )}
        {expanded && description ? (
            typeof description === 'string' ? (
                <P dangerouslySetInnerHTML={{ __html: description }} />
            ) : (
                description
            )
        ) : null}
    </Block>
)

export default withState(
    { expanded: false },
    { toggle: () => ({ expanded }) => ({ expanded: true }) }
)(Error)



// WEBPACK FOOTER //
// ./src/components/Error.js